import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PanelMenuComponent} from "./panel-menu.component";
import {TranslateModule} from "@ngx-translate/core";
import {ElementoHijoMenuModule} from "../elemento-hijo-menu/elemento-hijo-menu.module";
import {GestionUsuariosResumenModule} from "../gestion-usuarios-resumen/gestion-usuarios-resumen.module";
import {GestionRagResumenModule} from "../gestion-rag-resumen/gestion-rag-resumen.module";
import {GestionIntegracionesResumenModule} from "../gestion-integraciones-resumen/gestion-integraciones-resumen.module";

@NgModule({
  declarations: [
    PanelMenuComponent
  ],
  exports: [
    PanelMenuComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ElementoHijoMenuModule,
    GestionUsuariosResumenModule,
    GestionRagResumenModule,
    GestionIntegracionesResumenModule,
  ]
})
export class PanelMenuModule {
}
